import React from "react"

import { Button } from "~components/Explorer"
import FixedHeader from "./FixedHeader"
import RequestParams from "./Params"

import { request } from "./Request.module.scss"

const Request = ({ endpoint, explorer, microcopy }) => (
  <>
    {endpoint.params?.[0] && (
      <div id="request" className={request}>
        <Button explorer={explorer} endpoint={endpoint} />
        <header>
          <h2>
            <a href="#request" data-display-anchor>
              {microcopy.text("reference.titles.request")}
            </a>
          </h2>
        </header>

        {endpoint.requiresBearerToken && (
          <FixedHeader label="authorization" value="bearer [ACCESS_TOKEN]" />
        )}

        <FixedHeader
          label="content-type"
          value={
            endpoint.requestContentType
            || microcopy.text("reference.content_type.none")
          }
        />

        <br />

        <RequestParams
          explorer={explorer}
          endpoint={endpoint}
          microcopy={microcopy}
        />
      </div>
    )}
  </>
)

export default Request
